
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transactions/pfc-migration",
      function () {
        return require("private-next-pages/docs/transactions/pfc-migration.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transactions/pfc-migration"])
      });
    }
  